<template>
  <section class="w-full">
    <div class="pda-default">
      <div class="t-headline5">
        {{ $t("1598") }}
        <!-- 약관동의 -->
      </div>
      <div class="t-body3 mgt-6 t-color-content1">
        {{ $t("1599") }}
        <!-- 계속하면 아래 약관에 동의하는 것입니다. -->
      </div>

      <div class="mdc-card mdc-elevation--z3 pda-default mgt-35">
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-grow-1">
            <router-link :to="{ name: 'Join2Terms' }">
              <span class="t-color-title t-subtitle3">
                {{ $t("1600") }}
                <!-- 서비스 이용약관 -->
              </span>
            </router-link>
          </div>

          <div class="mdc-form-field mdc-form-field--align-end">
            <div class="mdc-checkbox">
              <input
                type="checkbox"
                class="mdc-checkbox__native-control"
                v-model="checkTerms"
                @change="handleCheckAll1"
              />
              <div class="mdc-checkbox__background check-red">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
            <label for="basic-checkbox t-button"></label>
          </div>
        </div>
        <router-link to="/terms">
          <div
            class="mgt-16 t-body3 h-60 scroll-y"
            v-html="htmlTermsOfService"
          ></div>
        </router-link>
        <!-- <div class="mgt-8 t-body3 t-color-gray3">Todo-발효일: 2020년 02월 14일</div> -->
        <div class="mgt-8 t-body3 t-color-BodygrayA">
          {{ $t("178", { str1: termsYear, str2: termsMonth, str3: termsDay }) }}
        </div>
      </div>

      <div class="mdc-card mdc-elevation--z3 pda-default mgt-16">
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-grow-1">
            <router-link :to="{ name: 'Join2Privacy' }">
              <span class="t-color-title t-subtitle3">
                {{ $t("1601") }}
                <!-- 개인정보 보호정책 -->
              </span>
            </router-link>
          </div>

          <div class="mdc-form-field mdc-form-field--align-end">
            <div class="mdc-checkbox">
              <input
                type="checkbox"
                class="mdc-checkbox__native-control"
                v-model="checkPrivacy"
                @change="handleCheckAll2"
              />
              <div class="mdc-checkbox__background check-red">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
            <label for="basic-checkbox t-button"></label>
          </div>
        </div>
        <router-link to="/privacy">
          <div
            class="mgt-16 t-body3 h-60 scroll-y"
            v-html="htmlPrivacypolicy"
          ></div>
        </router-link>

        <div class="mgt-8 t-body3 t-color-BodygrayA">
          {{
            $t("179", {
              str1: privacyYear,
              str2: privacyMonth,
              str3: privacyDay,
            })
          }}
        </div>
      </div>

      <hr class="divider mgt-16" />

      <div class="mdc-card mdc-elevation--z3 pda-default mgt-16">
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-grow-1">
            <span class="t-color-title t-subtitle3">
              {{ $t("1602") }}
              <!-- 전체 동의 -->
            </span>
          </div>

          <div class="mdc-form-field mdc-form-field--align-end">
            <div class="mdc-checkbox">
              <input
                type="checkbox"
                class="mdc-checkbox__native-control"
                v-model="checkAll"
                @change="handleCheckAll"
                :checked="validAgree"
              />
              <div class="mdc-checkbox__background check-red">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
            <label for="basic-checkbox t-button"></label>
          </div>
        </div>
      </div>

      <div class="mgt-50">
        <button class="mdc-button mdc-button--raised btn-red" @click="next()">
          {{ $t("1603") }}
          <!-- 다음 -->
        </button>
        <button
          class="mdc-button btn-white mgr-8 mgl-8"
          @click="cancelJoin()"
          type="button"
        >
          {{ $t("1604") }}
          <!-- 취소 -->
        </button>
      </div>
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
/**
 * 회원가입 - 약관동의 컴포넌트(sign up - pp & tnu component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCSelect } from "@material/select";
import { MDCFormField } from "@material/form-field";
import { MDCRadio } from "@material/radio";
import { MDCRipple } from "@material/ripple";
import joinApi from "@/api/joinApi.js";
import { mapState, mapMutations } from "vuex";
import { joinMixin } from "@/mixins/join.js";

export default {
  data() {
    return {
      checkTerms: false,
      checkPrivacy: false,
      checkAll: false,
      htmlPrivacypolicy: null,
      htmlTermsOfService: null,
      termsYear: "",
      termsMonth: "",
      termsDay: "",
      privacyYear: "",
      privacyMonth: "",
      privacyDay: "",
    };
  },

  mixins: [joinMixin],

  created() {
    if (!this.join.joinStart) {
      this.moveJoin2Intro();
    }
  },

  mounted() {
    // get terms & privacy contents
    joinApi
      .terms()
      .then((response) => {
        console.log(response.data.data);
        const termsUrl = response.data.data.TERMS_OF_SERVICE;
        const privacyUrl = response.data.data.PRIVACY_STATEMENT;

        joinApi.policyContents(termsUrl, "text").then((response) => {
          this.htmlTermsOfService = response.data;
        });

        joinApi.policyContents(privacyUrl, "text").then((response) => {
          this.htmlPrivacypolicy = response.data;
        });
      })
      .catch((err) => {});

    let privacyParams = { type: "PRIVACY_STATEMENT" };
    joinApi
      .termsDate(privacyParams)
      .then((response) => {
        if (response.data.data) {
          this.privacyYear = this.$moment(response.data.data).format("Y");
          this.privacyMonth = this.$moment(response.data.data).format("MM");
          this.privacyDay = this.$moment(response.data.data).format("DD");
        }
      })
      .catch((err) => {
        console.log("err=>", err);
      });

    let termsParams = { type: "TERMS_OF_SERVICE" };
    joinApi
      .termsDate(termsParams)
      .then((response) => {
        if (response.data.data) {
          this.termsYear = this.$moment(response.data.data).format("Y");
          this.termsMonth = this.$moment(response.data.data).format("MM");
          this.termsDay = this.$moment(response.data.data).format("DD");
        }
      })
      .catch((err) => {
        console.log("err=>", err);
      });
  },

  computed: {
    ...mapState("join", {
      join: (state) => state,
    }),

    validAgree() {
      this.checkAll = this.checkTerms && this.checkPrivacy;
      return this.checkAll;
    },
  },

  methods: {
    // Store 변이 정의(define store mutation)
    ...mapMutations("join", ["SET_TERMS"]),

    setMaterialUi() {
      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
    },

    handleCheckAll1() {
      this.checkTerms;
      this.checkPrivacy;
    },
    handleCheckAll2() {
      this.checkTerms;
      this.checkPrivacy;
    },

    // check all
    handleCheckAll() {
      console.log("checkTerms", this.checkTerms);
      console.log("checkPrivacy", this.checkPrivacy);
      if (this.checkAll) {
        this.checkTerms = true;
        this.checkPrivacy = true;
      } else {
        this.checkTerms = false;
        this.checkPrivacy = false;
      }
    },

    // next
    next() {
      if (this.checkAll) {
        let agreeDate = Date.now();
        this.SET_TERMS(agreeDate);

        if (
          this.join.socialLink.type === "google" ||
          this.join.socialLink.type === "facebook" ||
          this.join.socialLink.type === "firebase"
        ) {
          this.$router.push({
            name: "Join2Responsibility",
          });
        } else {
          this.$router.push({
            name: "Join2Responsibility",
          });
        }
      } else {
        this.$snackOpen({
          contents: this.$t("946"), //모든 약관에 동의해 주세요.
          btnDisplay: "",
        }).then(() => {});
      }
    },
  },
};
</script>